import { Component } from 'san';
import * as _ from 'lodash';
import axios from 'axios';
import toasterService from 'src/services/toaster.service';
import { IShowUpdatePasswordParams, IUpdatePasswordCallback } from 'src/models';
import userService from 'src/services/user.service';

export default class UpdatePassword extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        valid() {
            const data = this.data.get('data');
            if (this.data.get('userId')) {
                return data.password;
            }
            return data.old_password && data.password;
        },
    };

    initData(): {
        isShow: boolean;
        isFirstLogin: boolean;
        userId: string; // 需要重置密码的userId
        name: string; // 需要重置密码的userName
        data: { password: string; };
        current_user_name: string;
        callback: IUpdatePasswordCallback;
        cancelCallback: IUpdatePasswordCallback;
        showPassword: boolean;
    } {
        return {
            isShow: false,
            isFirstLogin: false,
            userId: '',
            name: '',
            data: { password: '' },
            current_user_name: '',
            callback: null,
            cancelCallback: null,
            showPassword: false
        };
    }

    getDefaultData() {
        if (this.data.get('userId')) {
            return _.cloneDeep({
                password: '',
                should_change_password: false,
            });
        }
        return _.cloneDeep({
            old_password: '',
            password: '',
        });
    }

    show(params?: IShowUpdatePasswordParams) {
        this.getCurrentUser();
        this.data.set('isShow', true);
        this.data.set('isFirstLogin', params?.isFirstLogin);
        this.data.set('userId', params?.userId);
        this.data.set('name', params?.name);
        this.data.set('callback', params?.callback);
        this.data.set('cancelCallback', params?.cancelCallback);
        this.data.set('data', this.getDefaultData());
    }

    getCurrentUser() {
        userService.getCurrentUser().then((user) => {
            this.data.set('current_user_name', user.name);
        });
    }

    toggleShowPassword() {
        this.data.set('showPassword', !this.data.get('showPassword'));
    }

    submit() {
        if (this.data.get('userId')) {
            // 管理员重置用户密码
            const data = this.data.get('data');
            const userId = this.data.get('userId');
            const command = Object.assign({}, data, { user_id: userId, confirm_password: data.password });
            return axios.put('/api/users/account/admin-update-password', command).then(() => {
                toasterService.show({ type: 'success', title: `用户“${this.data.get('name')}”的密码重置成功` });
                this.cancel();
                const callback = this.data.get('callback');
                if (callback) {
                    callback();
                }
            });
        } else {
            // 普通用户更改自己的密码
            const data = this.data.get('data');
            const command = Object.assign({}, data, { confirm_password: data.password });
            return axios.put(`/api/users/account/update-password`, command).then((result) => {
                if (result.data.success) {
                    this.cancel();
                    const callback = this.data.get('callback');
                    if (callback) {
                        callback();
                        return;
                    }
                    toasterService.show({ type: 'success', title: '密码更新成功' });
                } else {
                    const contents = _.uniq(_.map(result.data.errors, 'message'));
                    toasterService.show({
                        type: 'danger',
                        title: _.join(contents, '；'),
                    });
                }
            });
        }
    }

    cancel() {
        const cancelCallback = this.data.get('cancelCallback');
        if (cancelCallback) {
            cancelCallback();
        }
        this.data.set('isShow', false);
        this.data.set('isFirstLogin', false);
        this.data.set('userId', '');
        this.data.set('name', '');
        this.data.set('current_user_name', '');
        this.data.set('data', this.getDefaultData());
    }
}
